import { render, staticRenderFns } from "./TenantsGuideToRenting.vue?vue&type=template&id=23afffce&scoped=true&"
import script from "./TenantsGuideToRenting.vue?vue&type=script&lang=ts&"
export * from "./TenantsGuideToRenting.vue?vue&type=script&lang=ts&"
import style0 from "./TenantsGuideToRenting.vue?vue&type=style&index=0&id=23afffce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23afffce",
  null
  
)

export default component.exports